<div
  id="map"
  leaflet
  (leafletMapReady)="onMapReady($event)"
  [leafletOptions]="mapOptions"
  [leafletMarkerCluster]="markerClusterData"
></div>

<toast-license *appHasPermission="'license_module'"></toast-license>
<dialog-license *appHasPermission="'license_module'"></dialog-license>
